import type {MaskitoPreprocessor} from '@maskito/core';
import type {MetadataJson} from 'libphonenumber-js/core';
import {
    AsYouType,
    parsePhoneNumber,
    validatePhoneNumberLength,
} from 'libphonenumber-js/core';

const RU_PHONE_LENGTH = 11;

/**
 * https://github.com/taiga-family/maskito/blob/main/projects/phone/src/lib/masks/phone/processors/validate-phone-preprocessor.ts
 * Дополнительно добавлена логика по вставке RU номеров
 */
export function validatePhonePreprocessorGenerator({
    prefix,
    metadata,
}: {
    prefix: string;
    metadata: MetadataJson;
}): MaskitoPreprocessor {
    return ({elementState, data}) => {
        const {selection, value} = elementState;
        const cleanCode = prefix.trim();
        const countryIsoCode = data.length === RU_PHONE_LENGTH && (data.startsWith('7') || data.startsWith('8')) ? 'RU' : undefined;

        // handling autocomplete
        if (value && !value.startsWith(cleanCode) && !data) {
            const formatter = new AsYouType({defaultCountry: countryIsoCode}, metadata);

            formatter.input(value);
            const numberValue = formatter.getNumberValue() || '';

            formatter.reset();

            return {elementState: {value: formatter.input(numberValue), selection}};
        }

        try {
            const validationError = validatePhoneNumberLength(
                data,
                {defaultCountry: countryIsoCode},
                metadata,
            );

            if (!validationError) {
                // handle paste-event with different code, for example for 8 / +7
                const phone = countryIsoCode ? parsePhoneNumber(data, countryIsoCode, metadata) : parsePhoneNumber(data, metadata);

                const {nationalNumber, countryCallingCode} = phone;

                return {
                    elementState: {
                        selection,
                        value: '',
                    },
                    data: `+${countryCallingCode} ${nationalNumber}`,
                };
            }
        } catch {
            return {elementState};
        }

        return {elementState};
    };
}
